import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31d02409"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "print" }
const _hoisted_2 = { class: "pb-3" }
const _hoisted_3 = { class: "fw-bold d-flex align-items-center text-dark ms-3 mt-3 mt-lg-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "py-3" }
const _hoisted_8 = { class: "fw-bold d-flex align-items-center text-dark ms-3 mt-3 mt-lg-0" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "py-3" }
const _hoisted_13 = { class: "fw-bold d-flex align-items-center text-dark ms-3 mt-3 mt-lg-0" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_15 = { class: "box-container" }
const _hoisted_16 = { class: "d-flex bottom" }
const _hoisted_17 = { class: "col-9 col-md-10 left" }
const _hoisted_18 = { class: "col-3 col-md-2 right" }
const _hoisted_19 = {
  key: 0,
  class: "d-flex bottom"
}
const _hoisted_20 = { class: "col-9 col-md-10 left" }
const _hoisted_21 = { class: "mb-1" }
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "mb-1" }
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "mb-1" }
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "col-3 col-md-2 right" }
const _hoisted_28 = {
  key: 1,
  class: "d-flex bottom"
}
const _hoisted_29 = { class: "col-9 col-md-10 left" }
const _hoisted_30 = { class: "mb-1" }
const _hoisted_31 = ["href"]
const _hoisted_32 = { class: "mb-1" }
const _hoisted_33 = ["href"]
const _hoisted_34 = { class: "mb-1" }
const _hoisted_35 = ["href"]
const _hoisted_36 = { class: "col-3 col-md-2 right" }
const _hoisted_37 = {
  key: 2,
  class: "d-flex bottom"
}
const _hoisted_38 = { class: "col-9 col-md-10 left" }
const _hoisted_39 = { class: "mb-1" }
const _hoisted_40 = ["href"]
const _hoisted_41 = { class: "mb-1" }
const _hoisted_42 = ["href"]
const _hoisted_43 = { class: "mb-1" }
const _hoisted_44 = ["href"]
const _hoisted_45 = { class: "mb-1" }
const _hoisted_46 = ["href"]
const _hoisted_47 = { class: "col-3 col-md-2 right" }
const _hoisted_48 = { class: "d-flex bottom" }
const _hoisted_49 = { class: "col-9 col-md-10 left" }
const _hoisted_50 = { class: "mb-1" }
const _hoisted_51 = ["href"]
const _hoisted_52 = { class: "mb-1" }
const _hoisted_53 = ["href"]
const _hoisted_54 = { class: "mb-1" }
const _hoisted_55 = ["href"]
const _hoisted_56 = { class: "mb-1" }
const _hoisted_57 = ["href"]
const _hoisted_58 = { class: "col-3 col-md-2 right" }
const _hoisted_59 = { class: "d-flex bottom" }
const _hoisted_60 = { class: "col-9 col-md-10 left" }
const _hoisted_61 = { class: "col-3 col-md-2 right" }
const _hoisted_62 = { class: "d-flex bottom" }
const _hoisted_63 = { class: "col-9 col-md-10 left" }
const _hoisted_64 = { class: "col-3 col-md-2 right" }
const _hoisted_65 = { class: "d-flex bottom" }
const _hoisted_66 = { class: "col-9 col-md-10 left" }
const _hoisted_67 = { class: "col-3 col-md-2 right" }
const _hoisted_68 = { class: "d-flex bottom" }
const _hoisted_69 = { class: "col-9 col-md-10 left" }
const _hoisted_70 = { class: "col-3 col-md-2 right" }
const _hoisted_71 = { class: "d-flex bottom" }
const _hoisted_72 = { class: "col-9 col-md-10 left" }
const _hoisted_73 = { class: "col-3 col-md-2 right" }
const _hoisted_74 = { class: "d-flex" }
const _hoisted_75 = { class: "col-9 col-md-10 left" }
const _hoisted_76 = { class: "text-decoration-underline" }
const _hoisted_77 = { class: "col-3 col-md-2 right" }

import { ref, inject } from "vue";
import { occupations } from "@/core/types/jp/verificationInfo";
import {
  accountTypes,
  accountTypesSelection,
  accountRolesSelection,
  moneyRange,
  mainIncomeSources,
  transactionMotives,
  mainFunds,
  experienceSelections,
  investmentPurposes,
  assetManagementPeriodSelection,
  financialInstiutionTypes,
  depositTypesSelection,
  investorDistinctionSelection,
} from "@/core/types/jp/verificationFinancial";
import { getDataByCode } from "@/core/data/phonesData";
import { isMobile } from "@/core/config/WindowConfig";
import { jpDocs } from "@/core/data/bcrDocs";

export default /*#__PURE__*/_defineComponent({
  __name: 'JpReview',
  setup(__props) {

const items = inject<any>("verificationDetails");
const colSize = isMobile.value ? 1 : 2;
function getLabelByValue(value, array) {
  const data = array.find((data) => data.value === value);
  return data ? data.label : null;
}

function searchByValue(value, range) {
  for (const key in range) {
    if (range[key].value === value) {
      return range[key].label;
    }
  }
  return null; // If no match found
}

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("title.personalInfo")), 1)
      ]),
      _hoisted_4,
      _createVNode(_component_el_descriptions, {
        column: _unref(colSize),
        size: "large",
        border: "",
        class: "pb-3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.firstName')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).info?.firstName), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.lastName')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).info?.lastName), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.nativeNameLast')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).info?.nativeNameLast), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.nativeNameFirst')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).info?.nativeNameFirst), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.gender')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).info?.gender == "0" ? _ctx.$t("fields.male") : _ctx.$t("fields.female")), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.birthdate')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).info?.birthday), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.postalCode')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).info?.postalCode), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.region')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).info?.region), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.village')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).info?.town), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.town')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).info?.town), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.street')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).info?.street), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.buildingNumber')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).info?.buildingNumber), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.email')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).info?.email), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.phone')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).info?.phone), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.occupation')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(_unref(items).info?.occupation, _unref(occupations))), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.companyName')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).info?.companyName), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.affiliatedDepartment')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).info?.affiliatedDepartment), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.affiliatedPosition')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).info?.affiliatedPosition), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          (_unref(items).info?.citizen != true)
            ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                key: 0,
                label: _ctx.$t('fields.nationalityInformation')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(getDataByCode)(_unref(items).info?.citizen)?.name), 1)
                ]),
                _: 1
              }, 8, ["label"]))
            : (_openBlock(), _createBlock(_component_el_descriptions_item, {
                key: 1,
                label: _ctx.$t('fields.nationalityInformation')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(getDataByCode)(_unref(items).info?.otherCitizen)?.name), 1)
                ]),
                _: 1
              }, 8, ["label"])),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.countryOfResidence')
          }, {
            default: _withCtx(() => [
              (_unref(items).info.countryOfResidence == 'jp')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(getDataByCode)(_unref(items).info?.countryOfResidence)?.name), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("fields.residenceThanJapan")), 1))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.usTaxLiability')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).info?.usTax == true ? _ctx.$t("action.yes") : _ctx.$t("action.no")), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          (_unref(items).info?.declarationRegardingForeignPeps != true)
            ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                key: 2,
                label: _ctx.$t('fields.declarationRegardingForeignPeps')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.no")), 1)
                ]),
                _: 1
              }, 8, ["label"]))
            : (_openBlock(), _createBlock(_component_el_descriptions_item, {
                key: 3,
                label: _ctx.$t('fields.declarationRegardingForeignPeps')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(items).info?.otherPeps), 1)
                ]),
                _: 1
              }, 8, ["label"]))
        ]),
        _: 1
      }, 8, ["column"]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t("title.financial")), 1)
      ]),
      _hoisted_9,
      _createVNode(_component_el_descriptions, {
        column: _unref(colSize),
        border: "",
        class: "pb-lg-3",
        size: "large"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.accountType')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(_unref(items).financial?.accountRole, _unref(accountRolesSelection))), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.preferredTradingAccount')
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items).financial?.accountTypes, (item) => {
                return (_openBlock(), _createElementBlock("div", { key: item }, _toDisplayString(getLabelByValue(item, _unref(accountTypesSelection))), 1))
              }), 128))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.investorDistinction'),
            span: 2
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items).financial?.investorDistinction, (item) => {
                return (_openBlock(), _createElementBlock("div", { key: item }, _toDisplayString(getLabelByValue(item, _unref(investorDistinctionSelection))), 1))
              }), 128))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.annualIncome')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(searchByValue(_unref(items).financial?.annualIncome, _unref(moneyRange))), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.valueOfInvestment')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(searchByValue(_unref(items).financial?.investment, _unref(moneyRange))), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.amountOfInvestmentFunds')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(searchByValue(_unref(items).financial?.investmentFunds, _unref(moneyRange))), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.mainSourceOfIncome')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(_unref(items).financial?.mainIncomeSource, _unref(mainIncomeSources))), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.transactionMotive')
          }, {
            default: _withCtx(() => [
              (!_unref(items).financial?.transactionMotiveOther)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(getLabelByValue(
                _unref(items).financial?.transactionMotive,
                _unref(transactionMotives)
              )), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString((_unref(items).financial?.transactionMotive, _unref(transactionMotives))), 1))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.characteristicsOfMainFunds')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(_unref(items).financial?.mainFund, _unref(mainFunds))), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.assetManagementPeriod')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(
            _unref(items).financial?.assetManagementPeriod,
            _unref(assetManagementPeriodSelection)
          )), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: 'FX' + ' (' + _ctx.$t('fields.foreignExchangeMarginTrading') + ')'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(_unref(items).financial?.fx, _unref(experienceSelections))), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.stockTradingSpot')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(
            _unref(items).financial?.stockTradingSpot,
            _unref(experienceSelections)
          )), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.stockTradingCredit')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(
            _unref(items).financial?.stockTradingCredit,
            _unref(experienceSelections)
          )), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.indexOption')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(_unref(items).financial?.indexOption, _unref(experienceSelections))), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.commodityFuturesTrading')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(
            _unref(items).financial?.commodityFuturesTrading,
            _unref(experienceSelections)
          )), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.otherDerivativesTransaction')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(
              _unref(items).financial?.otherDerivativesTransaction,
              _unref(experienceSelections)
            )), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.investmentPurpose')
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items).financial?.investmentPurpose, (item) => {
                return (_openBlock(), _createElementBlock("div", { key: item }, _toDisplayString(getLabelByValue(item, _unref(investmentPurposes))), 1))
              }), 128))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.financialInstiutionName')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).financial?.financialInstiutionName), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.financialInstiutionType')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(
            _unref(items).financial?.financialInstiutionType,
            _unref(financialInstiutionTypes)
          )), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.branchName')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).financial?.branchName), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.branchCode')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_unref(items).financial?.branchCode), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.accountNumber')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_unref(items).financial?.accountNumber), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.depositType')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(_unref(items).financial?.depositType, _unref(depositTypesSelection))), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.financialInstiutionName')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).financial?.financialInstiutionName), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.accountHolderFullWidthKatakana')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).financial?.accountHolderFullWidthKatakana), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["column"]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("h2", _hoisted_13, _toDisplayString(_ctx.$t("title.agreement")), 1)
      ]),
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("type.jpAgreement.check1")), 1),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_el_form_item, {
              prop: "check_1",
              class: "d-flex align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _unref(items).agreement.check_1,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(items).agreement.check_1) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("fields.iAccept")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        (_unref(items).financial.accountTypes.includes(_unref(accountTypes).margin))
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("a", {
                    href: _unref(jpDocs).foreignExchangeMarginTrading.src,
                    target: "_blank",
                    class: "pdf"
                  }, _toDisplayString(_unref(jpDocs).foreignExchangeMarginTrading.title), 9, _hoisted_22)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("a", {
                    href: _unref(jpDocs).foreignExchangeTermsAndConditions.src,
                    target: "_blank",
                    class: "pdf"
                  }, _toDisplayString(_unref(jpDocs).foreignExchangeTermsAndConditions.title), 9, _hoisted_24)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("a", {
                    href: _unref(jpDocs).foreginExchangeTradingManual.src,
                    target: "_blank",
                    class: "pdf"
                  }, _toDisplayString(_unref(jpDocs).foreginExchangeTradingManual.title), 9, _hoisted_26)
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_el_form_item, {
                  prop: "check_2",
                  class: "d-flex align-items-center justify-content-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      modelValue: _unref(items).agreement.check_2,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(items).agreement.check_2) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("fields.iAccept")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(items).financial.accountTypes.includes(_unref(accountTypes).cfdTrading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("a", {
                    href: _unref(jpDocs).foreignExchangeMarginTrading.src,
                    target: "_blank",
                    class: "pdf"
                  }, _toDisplayString(_unref(jpDocs).foreignExchangeMarginTrading.title), 9, _hoisted_31)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("a", {
                    href: _unref(jpDocs).cfdTradingTermsAndConditions.src,
                    target: "_blank",
                    class: "pdf"
                  }, _toDisplayString(_unref(jpDocs).cfdTradingTermsAndConditions.title), 9, _hoisted_33)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("a", {
                    href: _unref(jpDocs).cfdTradingManual.src,
                    target: "_blank",
                    class: "pdf"
                  }, _toDisplayString(_unref(jpDocs).cfdTradingManual.title), 9, _hoisted_35)
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_el_form_item, {
                  prop: "check_3",
                  class: "d-flex align-items-center justify-content-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      modelValue: _unref(items).agreement.check_3,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(items).agreement.check_3) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("fields.iAccept")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (
            _unref(items).financial.accountTypes.includes(_unref(accountTypes).productTrading)
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("a", {
                    href: _unref(jpDocs).productCfdTrading.src,
                    target: "_blank",
                    class: "pdf"
                  }, _toDisplayString(_unref(jpDocs).productCfdTrading.title), 9, _hoisted_40)
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("a", {
                    href: _unref(jpDocs).commodityCfdTradingTermsAndConditions.src,
                    target: "_blank",
                    class: "pdf"
                  }, _toDisplayString(_unref(jpDocs).commodityCfdTradingTermsAndConditions.title), 9, _hoisted_42)
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("a", {
                    href: _unref(jpDocs).productCfdTradingManual.src,
                    target: "_blank",
                    class: "pdf"
                  }, _toDisplayString(_unref(jpDocs).productCfdTradingManual.title), 9, _hoisted_44)
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("a", {
                    href: _unref(jpDocs).productCfdTradingForCorporations.src,
                    target: "_blank",
                    class: "pdf"
                  }, _toDisplayString(_unref(jpDocs).productCfdTradingForCorporations.title), 9, _hoisted_46)
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_el_form_item, {
                  prop: "check_4",
                  class: "d-flex align-items-center justify-content-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      modelValue: _unref(items).agreement.check_4,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(items).agreement.check_4) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("fields.iAccept")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("a", {
                href: _unref(jpDocs).agreementRegardingElectronicDelivery.src,
                target: "_blank",
                class: "pdf"
              }, _toDisplayString(_unref(jpDocs).agreementRegardingElectronicDelivery.title), 9, _hoisted_51)
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("a", {
                href: _unref(jpDocs).personalInformationProtectionDeclaration.src,
                target: "_blank",
                class: "pdf"
              }, _toDisplayString(_unref(jpDocs).personalInformationProtectionDeclaration.title), 9, _hoisted_53)
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("a", {
                href: _unref(jpDocs).agreementForAntiSocialForce.src,
                target: "_blank",
                class: "pdf"
              }, _toDisplayString(_unref(jpDocs).agreementForAntiSocialForce.title), 9, _hoisted_55)
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("a", {
                href: _unref(jpDocs).notificationOfNotFallingUnderForeignPeps.src,
                target: "_blank",
                class: "pdf"
              }, _toDisplayString(_unref(jpDocs).notificationOfNotFallingUnderForeignPeps.title), 9, _hoisted_57)
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createVNode(_component_el_form_item, {
              prop: "check_5",
              class: "d-flex align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _unref(items).agreement.check_5,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(items).agreement.check_5) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("fields.iAccept")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", null, "①" + _toDisplayString(_ctx.$t("type.jpAgreement.check2Title")), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("type.jpAgreement.check2")), 1)
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createVNode(_component_el_form_item, {
              prop: "check_6",
              class: "d-flex align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _unref(items).agreement.check_6,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(items).agreement.check_6) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.yes")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", null, "②" + _toDisplayString(_ctx.$t("type.jpAgreement.check3Title")), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("type.jpAgreement.check3")), 1)
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createVNode(_component_el_form_item, {
              prop: "check_7",
              class: "d-flex align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _unref(items).agreement.check_7,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(items).agreement.check_7) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.yes")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_65, [
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", null, "③" + _toDisplayString(_ctx.$t("type.jpAgreement.check4Title")), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("type.jpAgreement.check4")), 1)
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createVNode(_component_el_form_item, {
              prop: "check_8",
              class: "d-flex align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _unref(items).agreement.check_8,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(items).agreement.check_8) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.yes")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", null, "④" + _toDisplayString(_ctx.$t("type.jpAgreement.check5Title")), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("type.jpAgreement.check5")), 1)
          ]),
          _createElementVNode("div", _hoisted_70, [
            _createVNode(_component_el_form_item, {
              prop: "check_9",
              class: "d-flex align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _unref(items).agreement.check_9,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(items).agreement.check_9) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.yes")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("div", null, "⑤" + _toDisplayString(_ctx.$t("type.jpAgreement.check6Title")), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("type.jpAgreement.check6")), 1)
          ]),
          _createElementVNode("div", _hoisted_73, [
            _createVNode(_component_el_form_item, {
              prop: "check_10",
              class: "d-flex align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _unref(items).agreement.check_10,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(items).agreement.check_10) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.yes")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.$t("type.jpAgreement.check7")), 1)
          ]),
          _createElementVNode("div", _hoisted_77, [
            _createVNode(_component_el_form_item, {
              prop: "check_11",
              class: "d-flex align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _unref(items).agreement.check_11,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(items).agreement.check_11) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.yes")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})